export default __webpack_public_path__ + "static/media/image-interactive.1d330522.jpg";